module.exports = __webpack_public_path__ + "static/img/tkty.722ea166.png";